module.exports = __webpack_public_path__ + "411d4570161b69ac97a8a575b77b0d7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/bottas2.jpg
// module id = 682
// module chunks = 2